import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { get } from 'lodash';
import { MessageBar } from 'office-ui-fabric-react';
import { Text } from 'office-ui-fabric-react/lib/Text';
import clsx from 'clsx';
import { getUser } from '../../utils/auth';
import Link from '../Link';
import styles from './ContractAttachmentsActionRequired.style';

/**
 * Info module for a contract to display specific messaging to the user based on
 * the approval status of a contract attachments.
 *
 */
const ContractAttachmentsActionRequired = ({ contractId, className: classNameProp, ...other }) => {
  const className = clsx(styles.root, classNameProp);
  const { contractAddress } = useParams();
  const attachments = useSelector(state =>
    get(state, `entities.contracts.${contractId}.attachments`, []),
  );

  const user = getUser();

  // valid approval status in which we should show the action required module:
  const attachmentActionRequiredStatus = 'PendingApproval';
  const pendingAttachments = attachments.filter(
    attachment =>
      attachment.approvalStatus === attachmentActionRequiredStatus &&
      attachment.reviewer?.oid === user.profile?.oid,
  );
  if (!pendingAttachments?.length) {
    return <></>;
  }

  return (
    <MessageBar
      isMultiline
      messageBarIconProps={{ iconName: 'Error' }}
      className={className}
      {...other}
    >
      <div>
        <Text as="p" className={styles.actionRequiredTitle}>
          Action required
        </Text>
      </div>

      <Text as="p" block className={styles.actionRequiredBody}>
        This contract has been updated with{' '}
        <strong>
          {pendingAttachments.length} Partner View{' '}
          {pendingAttachments.length > 1 ? 'attachments' : 'attachment'}.
        </strong>{' '}
        Please navigate to <strong>attachments tab or</strong>
        <Link className={styles.showLinkText} href={`/contracts/${contractAddress}/attachments`}>
          click here&nbsp;
        </Link>
        to <strong>review and approve</strong> the documents for Partner visibility.
      </Text>
    </MessageBar>
  );
};

ContractAttachmentsActionRequired.propTypes = {
  /**
   * Contract ID
   */
  contractId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

ContractAttachmentsActionRequired.defaultProps = {
  className: '',
};

export default ContractAttachmentsActionRequired;
